import { render } from "./runningGame.vue?vue&type=template&id=10f0c8b0&scoped=true"
import script from "./runningGame.vue?vue&type=script&lang=js"
export * from "./runningGame.vue?vue&type=script&lang=js"

import "./runningGame.vue?vue&type=style&index=0&id=10f0c8b0&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f0c8b0"]])

export default __exports__